export interface StockLoanSideType {
  lender: string
  borrower: string
}

export const stockLoanSide: StockLoanSideType = {
  lender: 'Lender',
  borrower: 'Borrower',
}
